import React from 'react';
import {SkeletonBlock} from '@aboutyou/ui-components';

export const BasketTotalSkeleton = () => {
  return (
    <>
      <SkeletonBlock $width="45%" $height="20px" />
      <SkeletonBlock $width="55%" $height="20px" />
      <SkeletonBlock $width="35%" $height="20px" />
      <SkeletonBlock $width="100%" $height="40px" />
    </>
  );
};
